import { render, staticRenderFns } from "./Champs.vue?vue&type=template&id=483673da&"
import script from "./Champs.vue?vue&type=script&lang=js&"
export * from "./Champs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports